module.exports = __webpack_public_path__ + "img/Multiple Submissions.7bebab83.svg";